import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContactService } from '../services/contact.service';

@Pipe({
  name: 'contact'
})
export class ContactPipe implements PipeTransform {

  constructor(private _contactService: ContactService){ }

  transform(value: number): Observable<string> {
    if(typeof(value) !== 'number') return of(null);
    return this._contactService.getContactById(value, true).pipe(map(x => [x.contactperspublicid, x.contactperssalutation, x.contactpersfname, x.contactperslname].filter(x => x? true: false).join(' ')));
  }

}
